import { render, staticRenderFns } from "./StationPlaceEventTable.vue?vue&type=template&id=a38bcb82&scoped=true&"
import script from "./StationPlaceEventTable.vue?vue&type=script&lang=js&"
export * from "./StationPlaceEventTable.vue?vue&type=script&lang=js&"
import style0 from "./StationPlaceEventTable.vue?vue&type=style&index=0&id=a38bcb82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38bcb82",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaceEventTable.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a38bcb82')) {
      api.createRecord('a38bcb82', component.options)
    } else {
      api.reload('a38bcb82', component.options)
    }
    module.hot.accept("./StationPlaceEventTable.vue?vue&type=template&id=a38bcb82&scoped=true&", function () {
      api.rerender('a38bcb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/StationPlaceEventTable.vue"
export default component.exports